"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("../../Grid"));
var NameField_1 = __importDefault(require("./NameField"));
var PhoneOrEmailField_1 = __importDefault(require("./PhoneOrEmailField"));
var CommentField_1 = __importDefault(require("./CommentField"));
var SubmitButton_1 = __importDefault(require("./SubmitButton"));
var Files_1 = __importDefault(require("./Files"));
var useOnOk_1 = __importDefault(require("../hooks/useOnOk"));
var Form = function () {
    var onOk = (0, useOnOk_1.default)();
    return (react_1.default.createElement("form", { onSubmit: onOk },
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 3 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(NameField_1.default, null)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(PhoneOrEmailField_1.default, null)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(CommentField_1.default, null)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Files_1.default, null)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(SubmitButton_1.default, null)))));
};
exports.default = Form;
